module.exports = __webpack_public_path__ + "img/emma-newman.c3360c3c.png";